var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yc-body-single-view-container"},[_c('div',{staticClass:"yc-container-scroll flex-fit main-content"},[_c('x-nav-menu',{attrs:{"x-options":_vm.options.content.menu}}),_c('Header'),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }